import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['show', 'form', 'text'];

  connect() {
    const liElement = this.element.closest('li');
    if (!liElement) return;

    this.element.closest('li').classList.remove('non-printable');
  }

  show() {
    this.showTarget.classList.add('hidden');
    this.textTarget.classList.add('hidden');
    this.formTarget.classList.remove('hidden');
  }

  hide() {
    this.showTarget.classList.remove('hidden');
    this.textTarget.classList.remove('hidden');
    this.formTarget.classList.add('hidden');
  }
}
